export const SET_MANUAL_CAMPAIGNS = 'CampaignsDB/SET_MANUAL_CAMPAIGNS';
export const SET_COUPON_CAMPAIGNS = 'CampaignsDB/SET_COUPON_CAMPAIGNS';
export const SET_COUPON_RULES = 'CampaignsDB/SET_COUPON_RULES';
